const clearFix = () => {
  return `
    &::before,
    &::after {
      content: ' ';
      display: table;
    }
    &::after {
      clear: both;
    }
  `
}

export default clearFix
